import script from "./ProfilForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfilForm.vue?vue&type=script&setup=true&lang=js"

import "./ProfilForm.vue?vue&type=style&index=0&id=3ea405b5&computed=true&lang=css"

const __exports__ = script;

export default __exports__